import SimpleLightbox from "simplelightbox";
import "simplelightbox/dist/simple-lightbox.min.css";

document.addEventListener("DOMContentLoaded", function () {
  const galleryBlocks = document.querySelectorAll(
    ".wp-block-gallery, .w-gallery"
  );

  if (galleryBlocks.length > 0) {
    galleryBlocks.forEach((galleryBlock) => {
      const links = galleryBlock.querySelectorAll(
        ".wp-block-gallery .wp-block-image >  a,  .w-gallery .w-gallery-item"
      );
      if (links.length > 0) {
        const lightbox = new SimpleLightbox(links, {
          captionPosition: "bottom",
          captionsData: "data-caption",
          close: true,
          captions: false, // Disable default captions
          scrollZoom: false,
          showCounter: false,
          animationSlide: false,
          animationSpeed: 0,
          fadeSpeed: 100,
        });
        const galleryItems = galleryBlock.querySelectorAll(
          ".wp-block-gallery .wp-block-image,  .w-gallery  .w-gallery-item"
        );
        galleryItems.forEach((item) => {
          const link =
            item.querySelector(".wp-block-image > a, .w-gallery-item") || item;
          const figcaption = item.querySelector(
            ".wp-element-caption, .w-gallery-item-title"
          );
          if (link && figcaption) {
            link.setAttribute("data-caption", figcaption.innerHTML);
          }
        });
        lightbox.on("shown.simplelightbox", function () {
          setTimeout(function () {
            updateCaptionAndCounter(lightbox);
          }, 120);
        });
        lightbox.on("nextImageLoaded.simplelightbox", function () {
          setTimeout(function () {
            updateCaptionAndCounter(lightbox);
          }, 120);
        });

        function updateCaptionAndCounter(lightbox) {
          const total = lightbox.elements.length;
          const current = lightbox.currentImageIndex + 1;
          const caption =
            lightbox.elements[lightbox.currentImageIndex].getAttribute(
              "data-caption"
            ) || "";
          const lightboxContainer = document.querySelector(
            ".sl-wrapper .sl-image"
          );
          if (lightboxContainer) {
            let wrapper = lightboxContainer.querySelector(".sl-bottom-wrapper");
            if (!wrapper) {
              lightboxContainer.insertAdjacentHTML(
                "beforeend",
                `<div class="sl-bottom-wrapper"></div>`
              );
              wrapper = lightboxContainer.querySelector(".sl-bottom-wrapper");
            } else {
              wrapper.innerHTML = "";
            }
            if (caption) {
              wrapper.innerHTML += `<div class="sl-caption-inside">${caption}</div>`;
            }
            wrapper.innerHTML += `<div class="sl-counter-bottom">${current} of ${total}</div>`;
          }
        }
      }
    });
  }
});
